import { Theme } from '@mui/system'
import { makeStyles } from '@mui/styles'
import { SPACES } from 'src/constants'

export const useStyles = makeStyles((theme: Theme) => ({
  container: {
    '&&': {
      display: 'flex',
      columnGap: SPACES.xl,
      rowGap: SPACES.s,
      flexWrap: 'wrap',
      marginRight: SPACES.xl,
    },
  },
  linkIcon: {
    height: 16,
    width: 'auto',
  },
}))
